import React from 'react';
import { Container, Row, Col, Card, Image, Button } from 'react-bootstrap';
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const FTPSetupGuide = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 div-shadow mb-3">
          <h1 className="head-color">Beginner's Guide to Setting Up FTP Accounts in cPanel on Namecheap Hosting</h1>
          <span className="small ms-2"><b>Publish By:</b> CodeInputs</span>
          
          <Image src="/graphics/images/FTP.webp" fluid alt="FTP setup" className="my-3" />
          
          <p className="blacktext">
            Are you new to managing a website and looking to set up FTP accounts in cPanel on Namecheap hosting? This guide is designed just for you. In this beginner-friendly article, we'll walk you through the steps needed to create, configure, and manage FTP accounts, allowing you to securely upload, download, and organize files for your website. We'll explain what FTP (File Transfer Protocol) is, how it can simplify your website management, and why it's essential for accessing and updating your site's files. By the end, you’ll have a clear understanding of how to set up FTP accounts on your Namecheap hosting account and tips for keeping your site secure.
          </p>

          <h4>What is FTP?</h4>
          <p className="blacktext">
            FTP, or File Transfer Protocol, is a standard network protocol used to transfer files between a client and a server over the internet. Essentially, FTP allows users to upload, download, delete, and manage files on a website's server.
          </p>

          <p className="mt-4 blacktext">It’s a useful tool for website owners, developers, and anyone who needs to manage or update website files. With FTP, you can organize your files directly on the server, making it easier to update your website, back up important data, or troubleshoot problems. To use FTP, you typically need an FTP client (such as FileZilla), an FTP server address, a username, and a password to connect to the server.</p>

                <p className="mt-4 blacktext">FTP is widely used because it’s reliable and works with most hosting services, although many people now use secure versions of FTP, like SFTP (Secure File Transfer Protocol) or FTPS (FTP Secure), which add encryption to protect data during transfer.</p>
          <Image src="/graphics/images/FTP_process.webp" fluid alt="FTP process" className="my-3" />

         <p className="mt-4 blacktext">After logging into your cPanel account, you'll see your cPanel dashboard.  follow these steps:</p>
                <ol className="blacktext">
                  <li><b className="orgspan">Locate the File Section</b>: Scroll down to find the "File" section on the dashboard.</li>
                  <div className="row mt-3">
                    <div className="col-md-12">
                      <img className="img-responsive" src="/images/ftp_dashboard.webp" alt="FTP" />
                    </div>
                  </div>
                  
                  <li><b className="orgspan">Click on "FTP Accounts"</b>: This will take you to a screen where you can see a form to Add new ftp account.</li>
                  <div className="row mt-3">
                    <div className="col-md-12">
                      <img className="img-responsive" src="/images/ftpaccount.webp" alt="cpanel dashboard" />
                    </div>
                  </div>

                  <li><b className="orgspan">Create a New FTP Account:</b>Fill your new FTP account detail and select the domain or subdomain for which you want to create an FTP account. you can mention the directory name in which ftp account will be created.</li><br />

                  <p className="text-dark"><b>Login:</b> Enter the desired username for your FTP account. This will be combined with your main domain to form the full username (e.g., username@yourdomain.com).</p>

                  <p className="text-dark"><b>Domain:</b> Select the domain you want to associate with this FTP account from the dropdown menu.</p>
                  <div className="row mt-3">

                  <p className="text-dark"><b>Password:</b> Enter a strong password. You can use the "Password Generator" for a secure password.</p>

                  <p className="text-dark"><b>Password (Again):</b> Re-enter the password to confirm.</p>

                  <p className="text-dark"><b>Directory:</b> Specify the directory this FTP account will have access to. By default, cPanel suggests a directory based on the username. You can modify this to grant access to a specific folder.</p>

                  <p className="text-dark"><b>Quota:</b> Set the disk space limit for this FTP account or choose "Unlimited."</p>
                    <div className="col-md-12">
                      <img className="img-responsive" src="/images/ftp_details.webp" alt="FTP Setup" />
                    </div>
                  </div>

                  <li><b className="orgspan">Click on FTP "Create FTP Account"</b>: After filling the details of the new FTP account now you click on Create FTP Account button for creating new FTP.</li>

                  <div className="row mt-3">
                    <div className="col-md-12">
                      <img className="img-responsive" src="/images/create_ftp.webp" alt="Manage FTP" />
                    </div>
                  </div>

                  <li><b className="orgspan"> FTP Account lisitng</b>: Your new FTP account will now appear under the "FTP Accounts" section, where you can manage it further if needed.</li>

                  <div className="row mt-3">
                    <div className="col-md-12">
                      <img className="img-responsive" src="/images/ftplist.webp" alt="FTP List" />
                    </div>
                  </div>
                </ol>

          <center>
            <a href="https://youtu.be/5IBsJGiFgWQ">
              <h5>Watch More on FTP Accounts</h5>
              <Image src="/graphics/images/ytd-btn.png" alt="YouTube" />
            </a>
          </center>
        </Col>

        <Col sm={3} className="recent-post">
          <Card className="bg-white p-4 mb-3 div-shadow">
            <h4 className="head-color">Recent Post</h4>
            <RecentPost/>
          </Card>

          <Card className="bg-white p-4 div-shadow">
            <h4 className="head-color">Recent Comment</h4>
            <p style={{ color: "#85929e" }}>No Comments to Show</p>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default FTPSetupGuide;